import { LocalizedError } from "./localized-error";
import { TransTokens } from "../i18n/trans-tokens";

const tokens = TransTokens.create({
  NotFound: "Content could not be found.",
  StoryNotFound: "This story is not available.",
});

export class NotFoundError extends LocalizedError {
  constructor(message?: string) {
    super(new Error(message), tokens.NotFound);
  }
}

export class StoryNotFoundError extends LocalizedError {
  constructor(message?: string) {
    super(new Error(message), tokens.StoryNotFound);
    this.doNotCapture = true;
  }
}
